export default __webpack_public_path__ + "static/media/flag_IT-IT.4dff5c12.png";